var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: "", width: 1, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _c("ik-table-id", {
              ref: "input_" + scope.$index + "_" + "code",
              attrs: {
                line: scope.$index,
                code: _vm.code,
                name: _vm.name,
                "default-value": _vm.defaultValue,
                require: _vm.getRequire,
                rules: _vm.rules,
              },
              on: { onFieldChange: _vm.onFieldChange },
              model: {
                value: scope.row[_vm.code],
                callback: function ($$v) {
                  _vm.$set(scope.row, _vm.code, $$v)
                },
                expression: "scope.row[code]",
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }